module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('InnerMenu', {
    attrs: {
      "menu": _vm.menu
    }
  }, [(_vm.showPages) ? _c('router-view') : _c('Warning', [_c('p', [_vm._v("Данный раздел не работает в данный момент. Пожалуйста, возвращайтесь позднее!")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3393f874","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/Index.vue
// module id = d0ae64c4857752b95d9c
// module chunks = 77